<template>
  <v-menu v-model="menu" offset-y :close-on-content-click="false" top>
    <template v-slot:activator="{ on }">
      <v-chip
        class="block-chip"
        style="height: 100%"
        label
        link
        exact
        :color="getUnitIsPossible === true ? 'rgba(0, 0, 0, 0.05)' : 'error'"
        v-on="on"
      >
        <div class="tab-item">
          <v-row
            dense
            align="center"
            justify="space-between"
            style="white-space: normal;"
          >
            <v-col cols="12" sm="6">
              <v-row align="center" justify="start" no-gutters>
                <span class="overline mr-1" v-show="item.ordre !== null">{{
                  item.ordre
                }}</span>
                <span class="ingredient-title">{{
                  getAllProducts.find(x => x.id === item.pk_recette_produit).nom
                }}</span>
                <v-icon class="ml-3" small v-show="item.is_inventory_link"
                  >fa-link</v-icon
                >
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row dense no-gutters align="center" justify="space-between">
                <div>
                  <span class="subtitle-1">{{ item.quantite }}</span>
                  <span class="caption ml-1">{{ item.unite_mesure }}</span>
                </div>
                <div>
                  <span>{{ getIngredientValue }}</span>
                  <span class="caption ml-1">$</span>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-chip>
    </template>
    <v-card>
      <v-card-text>
        <IngredientEditor
          :recipe-id="recipeId"
          :item="item"
          :intermediate-product="intermediateProduct"
          :open-editors.sync="openEditors"
          @submit="menu = false"
        ></IngredientEditor>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mappers } from "@/mappers";
import { mapGetters } from "vuex";
import { productMixin } from "@/mixins";
import round10 from "round10";
import IngredientEditor from "./IngredientEditor.vue";
export default {
  name: "IngredientTabItem",
  components: {
    IngredientEditor
  },
  mixins: [productMixin],
  props: {
    recipeId: {
      required: true
    },
    item: {
      required: true
    },
    intermediateProduct: {
      required: true
    },
    openEditors: {
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["getAllProducts", "getAllowedUnits", "getCustomUnits"]),
    getUnitIsPossible() {
      return this.unitIsPossible();
    },
    getIngredientValue() {
      return this.getIngredientCost(this.item);
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    changeUnitMesure(value, item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      item.unite_mesure = value;
      if (product && product.data.use_alternative_unit === true) {
        let alt_unit_possibilities = [];
        if (
          !mappers.isCustomUnit(
            product.data.alternative_unite_mesure_production
          )
        ) {
          alt_unit_possibilities = this.$units()
            .from(product.data.alternative_unite_mesure_production)
            .possibilities()
            .filter(x => this.getAllowedUnits.includes(x));
        } else {
          alt_unit_possibilities = this.getCustomUnits;
        }
        item.is_alternative_unite_mesure = alt_unit_possibilities.includes(
          value
        );
      }
    },
    getPossibleUnitSelectionForProduct(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      try {
        return this.getProductUnitPossibilities(product);
      } catch {
        return [];
      }
    },
    unitIsPossible() {
      return this.getPossibleUnitSelectionForProduct(this.item).includes(
        this.item.unite_mesure
      );
    },
    getIngredientCost(item) {
      try {
        const product = this.getAllProducts.find(
          x => x.id === item.pk_recette_produit
        );
        if (product && product.data) {
          if (product.data.use_conversion_formula) {
            if (product.data.use_alternative_unit === true) {
              let alt_unit_possibilities = [];
              if (
                !mappers.isCustomUnit(
                  product.data.alternative_unite_mesure_production
                )
              ) {
                alt_unit_possibilities = this.$units()
                  .from(product.data.alternative_unite_mesure_production)
                  .possibilities()
                  .filter(x => this.getAllowedUnits.includes(x));
              } else {
                alt_unit_possibilities = this.getCustomUnits.map(x => x.name);
              }
              const is_alternative_unite_mesure = alt_unit_possibilities.includes(
                item.unite_mesure
              );
              if (is_alternative_unite_mesure) {
                if (
                  !mappers.isCustomUnit(item.unite_mesure) &&
                  !mappers.isCustomUnit(
                    product.data.alternative_unite_mesure_production
                  )
                ) {
                  const itemQtyInProductUnit = this.$units(item.quantite)
                    .from(item.unite_mesure)
                    .to(product.data.alternative_unite_mesure_production);
                  return round10.round10(
                    Number(product.data.alternative_price) *
                      itemQtyInProductUnit,
                    -4
                  );
                } else {
                  return round10.round10(
                    Number(product.data.alternative_price) * item.quantite,
                    -4
                  );
                }
              } else {
                if (
                  !mappers.isCustomUnit(item.unite_mesure) &&
                  !mappers.isCustomUnit(product.data.unite_mesure)
                ) {
                  const itemQtyInProductUnit = this.$units(item.quantite)
                    .from(item.unite_mesure)
                    .to(product.data.unite_mesure);
                  return round10.round10(
                    Number(product.data.prix) * itemQtyInProductUnit,
                    -4
                  );
                } else {
                  return round10.round10(
                    Number(product.data.prix) * item.quantite,
                    -4
                  );
                }
              }
            } else {
              if (
                !mappers.isCustomUnit(item.unite_mesure) &&
                !mappers.isCustomUnit(product.data.unite_mesure)
              ) {
                const itemQtyInProductUnit = this.$units(item.quantite)
                  .from(item.unite_mesure)
                  .to(product.data.unite_mesure);
                return round10.round10(
                  Number(product.data.prix) * itemQtyInProductUnit,
                  -4
                );
              } else {
                return round10.round10(
                  Number(product.data.prix) * item.quantite,
                  -4
                );
              }
            }
          } else {
            if (
              !mappers.isCustomUnit(item.unite_mesure) &&
              !mappers.isCustomUnit(product.data.unite_mesure_inventory)
            ) {
              const itemQtyInProductUnit = this.$units(item.quantite)
                .from(item.unite_mesure)
                .to(product.data.unite_mesure_inventory);
              return round10.round10(
                (Number(product.data.prix_inventory) /
                  product.data.quantity_inventory) *
                  itemQtyInProductUnit,
                -4
              );
            } else {
              return round10.round10(
                (Number(product.data.prix_inventory) /
                  product.data.quantity_inventory) *
                  item.quantite,
                -4
              );
            }
          }
        } else {
          console.error("Product not found");
          return 0;
        }
      } catch (e) {
        console.error(e);
        return 0;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tab-item {
  width: 100%;
  padding: 3px;
}
.ingredient-title {
  text-transform: capitalize;
  font-size: 0.9rem;
  font-weight: 500;
}
</style>
